import React from "react";
import Input from "../../components/inputs/Input";
import Select from "../../components/selects/Select";
import Text from "../../components/typography/Text";
import TypesContext from "../../contexts/types";
import Button from "../../components/buttons/Button";

export default ({
  data,
  setData,
  errors,
  setError,
  next,
  btnLabel,
  saved,
  loading
}) => {
  const { countries } = React.useContext(TypesContext);

  const country =
    typeof data["country"] === "string"
      ? countries.find(({ value }) => value === data["country"])
      : data["country"];

  const verifyData = () => {
    setError();
    let isOkay = true;
    if (!data["country"]) {
      setError({
        field: "country",
        message: "Please provide a country"
      });
      isOkay = false;
    }
    if (!data["city"]) {
      setError({
        field: "city",
        message: "Please provide a correct city"
      });
      isOkay = false;
    }
    if (isOkay) next();
  };

  return (
    <div className="oUserForm">
      <h3>Location and social</h3>
      <div className="oUserForm_inputs">
        <Select
          label="Country"
          options={countries}
          width="100%"
          selected={country}
          setSelected={value =>
            setData({
              field: "country",
              value: data["country"] === value ? null : value
            })
          }
          error={errors.some(({ field }) => field === "country")}
        />
        <Input
          label="City"
          required
          value={data["city"]}
          setValue={value => setData({ field: "city", value })}
          error={errors.some(({ field }) => field === "city")}
        />
        <Input
          label="Your website"
          value={data["website"]}
          setValue={value => setData({ field: "website", value })}
        />
      </div>
      <div className="oUserForm_socials">
        <h4>Social profiles</h4>
        <Text>Copy/paste URL of your social networks.</Text>
        <div className="oUserForm_inputs">
          <Input
            label="Linkedin"
            icon="linkedin"
            value={data["linkedin"]}
            setValue={value => setData({ field: "linkedin", value })}
          />
          <Input
            label="Twitter"
            icon="twitter"
            value={data["twitter"]}
            setValue={value => setData({ field: "twitter", value })}
          />
          <Input
            label="Dribbble"
            icon="dribbble"
            value={data["dribbble"]}
            setValue={value => setData({ field: "dribbble", value })}
          />
          <Input
            label="Instagram"
            icon="instagram"
            value={data["instagram"]}
            setValue={value => setData({ field: "instagram", value })}
          />
          <Input
            label="Youtube"
            icon="youtube"
            value={data["youtube"]}
            setValue={value => setData({ field: "youtube", value })}
          />
          <Input
            label="Vimeo"
            icon="vimeo"
            value={data["vimeo"]}
            setValue={value => setData({ field: "vimeo", value })}
          />
        </div>
      </div>
      <div className="oUserForm_notice">
        This site is protected by reCAPTCHA and the Google
        <a
          href="https://policies.google.com/privacy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>{" "}
        and
        <a
          href="https://policies.google.com/terms"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms of Service
        </a>{" "}
        apply.
      </div>
      {saved ? (
        <Button big green full>
          Saved !
        </Button>
      ) : (
        <Button onClick={verifyData} big full>
          {loading ? "Registering..." : btnLabel || "Continue"}
        </Button>
      )}
    </div>
  );
};
